export default __webpack_public_path__ + "static/media/event_pre_step.7aa7b1a9.png";